export default "__VITE_ASSET__CEMJvLjn__"